import type { ReactNode } from 'react';

export type ConceptGroup = 'flow' | 'config' | 'tracked' | 'operator';

export interface ExternalRef {
  label: string;
  href: string;
}

export interface Concept {
  /** URL anchor slug, kebab-case, unique. */
  slug: string;
  /** Display name, e.g. "Calibration". */
  name: string;
  group: ConceptGroup;
  /** One-line definition shown on the collapsed card. */
  oneLiner: string;
  /** Route paths where this concept appears in the portal. */
  seenOn: string[];
  /** Other concept slugs related to this one. */
  related: string[];
  /** Expanded body (1-2 paragraphs). Plain JSX. */
  expanded?: ReactNode;
  /** Cross-system source-of-truth pointers (e.g. CouncilVerdictSchema). */
  externalRefs?: ExternalRef[];
}

export const GROUP_TITLES: Record<ConceptGroup, string> = {
  flow: 'What flows through the system',
  config: 'How it is configured',
  tracked: 'What we track over time',
  operator: 'What operators see and do',
};

export const GROUP_ORDER: ConceptGroup[] = ['flow', 'config', 'tracked', 'operator'];
